export const LANG_CHANGED_EVENT = "langChanged";
//# sourceMappingURL=config.js.map